// extracted by mini-css-extract-plugin
export var button = "_nj-2";
export var card = "_nj-0";
export var closeButtonContainer = "_nj-3";
export var iconContainer = "_nj-1";